import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store';
import type { RootState } from '@/store';
import { BASE_URL } from '@/config';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const { isAuthenticated, authChecked } = useAppSelector((s: RootState) => s.auth);
  const location = useLocation();

  if (!authChecked) {
    return (
      <div className="flex min-h-[200px] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`${BASE_URL}login`} state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
